import { graphql } from "gatsby"

export const BblTwoColumnWrapperBlockFragment = graphql`
  fragment BblTwoColumnWrapperBlock on WpBlock {
    ... on WpBblTwoColumnWrapperBlock {
      name
      attributes {
        className
      }
    }
  }
`

// This is the string version of this that is used within previews and without WP prefixes
export const BblTwoColumnWrapperBlockPreview = `
    ... on BblTwoColumnWrapperBlock {
        name
        attributes {
            className
        }
    }
`
